import React from 'react';
import { map, sortBy, values } from 'lodash';
import styled from 'styled-components';
import { maxRoundScore, penalty } from '../firestore/room';

const UserList = styled.div`
    overflow: hidden;
    flex: 1;
`;

const UserRow = styled.div`
    display: flex;
    *:not(:first-child) {
        margin-left: 10px;
    }
`;

const UserCell =
    styled.div <
    { isCorrect: boolean | Date } >
    `
    ${(props) => !!props.isCorrect && 'color: green;'}

`;

export const Leaderboard = ({
    users,
    correctUsers,
    showRoundScores,
    scores,
}: {
    users: { [id: string]: any },
    correctUsers: { [id: string]: any },
    showRoundScores: boolean,
    scores: { [id: string]: number },
}) => {
    const orderedUsers = showRoundScores
        ? sortBy(values(users), (user) => correctUsers[user.id])
        : values(users);
    return (
        <UserList>
            <div>Leaderboard</div>
            {map(orderedUsers, (user, idx) => {
                const userIsCorrect = correctUsers ? correctUsers[user.id] : false;
                const userScore = scores[user.id] || 0;
                const roundScore = userIsCorrect ? maxRoundScore - penalty * idx : 0;

                return (
                    <UserRow key={user.id}>
                        <UserCell isCorrect={userIsCorrect}>{user.name}</UserCell>
                        <span>{showRoundScores ? userScore - roundScore : userScore}</span>
                        {showRoundScores && <span>+ {roundScore} </span>}
                    </UserRow>
                );
            })}
        </UserList>
    );
};
